import type { Shadows } from "@mui/material/styles";
import type { DesignTokens } from "./types";

export function buildShadows(tokens: DesignTokens): Shadows {
  const tokenShadows = tokens.shadows;

  // MUI expects exactly 25 shadow entries (indices 0–24).
  // We map our token shadows to sensible elevation levels.
  return [
    "none",                    // 0
    tokenShadows.xs,           // 1
    tokenShadows.sm,           // 2
    tokenShadows.sm,           // 3
    tokenShadows.md,           // 4
    tokenShadows.md,           // 5
    tokenShadows.md,           // 6
    tokenShadows.lg,           // 7
    tokenShadows.lg,           // 8
    tokenShadows.lg,           // 9
    tokenShadows.xl,           // 10
    tokenShadows.xl,           // 11
    tokenShadows.xl,           // 12
    tokenShadows["2xl"],       // 13
    tokenShadows["2xl"],       // 14
    tokenShadows["2xl"],       // 15
    tokenShadows["3xl"],       // 16
    tokenShadows["3xl"],       // 17
    tokenShadows["3xl"],       // 18
    tokenShadows["3xl"],       // 19
    tokenShadows["3xl"],       // 20
    tokenShadows["3xl"],       // 21
    tokenShadows["3xl"],       // 22
    tokenShadows["3xl"],       // 23
    tokenShadows["3xl"],       // 24
  ];
}

